import React, { useEffect } from "react";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import "./style.css";

const SimpleGallery = (props) => {
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: "#" + props.galleryID,
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, [props.galleryID]);

  return (
    <div
      className={`pswp-gallery ${
        props.items === 5 ? "grid-template-5" : "grid-template-4"
      }`}
      id={props.galleryID}
    >
      {props.images.map((image, index) => (
        <a
          href={image.thumbnailURL}
          data-pswp-src={image.thumbnailURL}
          data-pswp-width={image.width}
          data-pswp-height={image.height}
          key={props.galleryID + "-" + index}
          target="_blank"
          rel="noreferrer"
        >
          <img src={image.thumbnailURL} alt={`image_${index}`} />
        </a>
      ))}
    </div>
  );
};

export default SimpleGallery;
